import { Preloader } from '@/components/Preloader';
import { prettyDate } from '@/helpers/utils';
import { useGetRoundCountriesById } from '@/query/queries/history/useGetRoundCountriesById';
import { useGetRoundRepaymentProgressById } from '@/query/queries/history/useGetRoundRepaymentProgressById';
import { useGetRoundBrandsById } from '@/query/queries/history/useGetRoundBrandsById';
import { useGetRoundLoanGroupsById } from '@/query/queries/history/useGetRoundLoanGroupsById';
import { FundraisingSwitch } from './controls';
import { RoundDetailStats } from '../stats';
import { RoundDetailBrands } from '../brands';
import { RoundDetailCountries } from '../countries';
import { RoundDetailRepaymentProgress } from '../repayment';
import { RoundDetailGroups } from '../groups';
import { ROUND_STATUSES } from '../../constants';
import s from './index.module.scss';

export const RoundDetail = ({ selected, setSelected }) => {
  const fundraisingId = selected.id;
  const isPastRound = ![
    ROUND_STATUSES.upcoming.code,
    ROUND_STATUSES.in_progress.code,
  ].includes(selected.status);

  const { data: brands, isLoading: loadingBrands } =
    useGetRoundBrandsById(fundraisingId);

  const { data: countries, isLoading: loadingCountries } =
    useGetRoundCountriesById(fundraisingId, isPastRound);

  const { data: repaymentProgress, isLoading: loadingRepaymentProgress } =
    useGetRoundRepaymentProgressById(fundraisingId, isPastRound);

  const { data: loanGroups, isLoading: loadingLoanGroups } =
    useGetRoundLoanGroupsById(fundraisingId, isPastRound);

  const loading =
    loadingCountries ||
    loadingRepaymentProgress ||
    loadingBrands ||
    loadingLoanGroups;

  return (
    <div className={s.wrapper}>
      <h2 className="f-32 f-500">{prettyDate(selected.date, 'MMMM YYYY')}</h2>
      <FundraisingSwitch selected={selected} setSelected={setSelected} />
      <RoundDetailStats selectedFundraising={selected} />
      {loading ? (
        <Preloader className={s.preloader} />
      ) : (
        <>
          <RoundDetailBrands brands={brands} />
          {isPastRound && (
            <>
              <RoundDetailCountries data={countries} />
              <RoundDetailRepaymentProgress
                graph={repaymentProgress}
                selected={selected}
              />
              <RoundDetailGroups loanGroups={loanGroups} />
            </>
          )}
        </>
      )}
    </div>
  );
};
